import * as React from 'react'
import { ReactElement } from 'react'
import Note from '../../Note/Note'
import { DataPromise } from '../../../context/AxiosContext'
import { NoteOverviewDto } from '../../../config/noteConfig'
import Loading from '../../../components/Loading'
import useUser from '../../../hooks/useUser'
import { Card, makeStyles, tokens } from '@fluentui/react-components'
import { IFileDto } from '../../../config/fileConfig'

export type NoteListProps = {
    notes: DataPromise<NoteOverviewDto[]>
    file?: IFileDto
    reset: () => any
}

// const styles = mergeStyleSets({
//     stack: { marginLeft: theme.spacing.s1, marginRight: theme.spacing.s1 },
//     // https://stackoverflow.com/questions/37745051/make-div-fill-remaining-horizontal-space-in-flexbox
//     note: { flex: 1, maxWidth: 480 },
//     card: { margin: 0 },
// })

const useStyles = makeStyles({
    cardContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: tokens.spacingHorizontalS,
    },
    card: {
        flex: 1,
        minWidth: '290px',
        maxWidth: '480px',
        marginLeft: '0 !important',
        marginRight: '0 !important',
    },
})

export default function NoteList(props: NoteListProps): ReactElement {
    const { currentUser } = useUser()
    const styles = useStyles()

    const emptyNote: NoteOverviewDto = {
        id: null,
        content: '',
        isPrivate: false,
        createdByAuthor: currentUser,
        createdAt: null,
        updatedByAuthor: null,
        updatedAt: null,
        revisionCount: 0,
    }

    if (!props.notes.loaded) {
        return <Loading />
    }

    return (
        <div className={styles.cardContainer}>
            {[emptyNote, ...props.notes.data].map((note, index) => (
                <Card key={index} className={styles.card}>
                    <Note {...note} file={props.file} reset={props.reset} />{' '}
                </Card>
            ))}
        </div>
    )
}
